import React from "react";
import Typography from "@material-ui/core/Typography";
// import Typography, { TypographyProps } from '@material-ui/core/Typography';

const Caption = (props: any) => (
  <Typography variant="caption" component="label" gutterBottom {...props} />
);

export default Caption;
